import React, { useCallback, useMemo } from 'react';

import { View } from 'react-native';

import { useTranslation } from 'react-i18next';

import { chunk } from 'lodash';

import { PROFILE_AGE_RATING_ITEM } from 'config/testID';

import { ParentalControlRating } from 'store/user/reducer.types';

import SelectAgeRatingItem from './SelectAgeRatingItem';
import styles from './styles';

type Props = {
    data: {
        label: string;
        key: ParentalControlRating;
        isSelected: boolean;
    }[];
    onSelectAgeRating: (item: {
        label: string;
        key: ParentalControlRating;
        isSelected: boolean;
    }) => () => void;
};

const SelectAgeRating = ({ data, onSelectAgeRating }: Props) => {
    const { t } = useTranslation();

    const chunckedData = useMemo(() => chunk(data, data.length / 2), [data]);

    const findFirstIndex = useCallback(
        (label: string) =>
            data.findIndex((dataItem) => dataItem.label === label),
        [data],
    );

    return (
        <View style={styles.container}>
            {chunckedData.map((itemColumn, index) => (
                <View key={index}>
                    {itemColumn.map((item) => (
                        <SelectAgeRatingItem
                            testID={`${PROFILE_AGE_RATING_ITEM}_${item.key}`}
                            onSelect={onSelectAgeRating(item)}
                            key={item.key}
                            label={t(item.label)}
                            isSelected={item.isSelected}
                            index={findFirstIndex(item.label)}
                        />
                    ))}
                </View>
            ))}
        </View>
    );
};

export default SelectAgeRating;
